<template>
  <radio-group class="marketing-sms-form-senders"
               :value="value.sendType"
               :options="sendersOptions"
               :disabled="view"
               rules="required"
               name="Destinatários"
               center
               @input="emitSendType">
    <template v-slot:option-0>
      <marketing-form-senders-list v-if="isSegmentedList"
                                   :value="value.configuration"
                                   @input="emitInput('configuration', $event)" />
    </template>

    <template v-slot:option-2>
      <marketing-form-senders-external v-if="isExternalList"
                                       :value="value"
                                       :file="value.file"
                                       :channel-data="channelData"
                                       :edit="isEdit"
                                       :channel-type="channelType"
                                       @input="setExternalData"
                                       @fileMode="setFileMode" />
                                       
    </template>

    <template v-slot:option-3>
      <marketing-form-senders-custom-list v-if="isCustomSegmentedList"
                                          :value="configurationInObjectFormat"                                        
                                          @input="emitInput('configuration', $event)" 
                                          @change-timeFilterActive="$emit('change-timeFilterActive', $event)"/>
                                       
                                       
    </template>
  </radio-group>
</template>

<script>
import RadioGroup from "@components/form/RadioGroup";
import MarketingFormSendersExternal from "@components/modules/marketing/generic/form/senders/external/MarketingFormSendersExternal";
import MarketingFormSendersList from "@components/modules/marketing/generic/form/senders/list/MarketingFormSendersList";
import MarketingFormSendersCustomList from "@components/modules/marketing/generic/form/senders/custom-list/MarketingFormSendersCustomList";
import { cloneDeep } from "lodash";

export default {
  components: {
    MarketingFormSendersList,
    MarketingFormSendersExternal,
    RadioGroup,
    MarketingFormSendersCustomList
  },

  data() {
    return {
      totalLeads: 0,
      fileMode: false,
      hasSenderOptionChanged: false
    };
  },

  props: {
    channelType: {
      type: String,
      required: false,
    },
    channelData: {
      type: Object,
      required: false,
    },
    view: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {
          sendType: undefined,
          configuration: undefined,
          sourceNote: undefined,
          file: undefined,
        };
      },
    },
  },  

  methods: {    
    emitSendType(value) {  
      this.emitInput('configuration', undefined);    
      this.$nextTick(() => {
        this.emitInput("sendType", value);
      });      
    },
    setFileMode() {
      this.fileMode = true;
    },
    emitInput(key, val) {     
      const newVal = cloneDeep(this.value);
      newVal[key] = val;
      
      this.$emit("has-edited");
      this.$emit("input", newVal);
      this.hasSenderOptionChanged = true;
    },
    setExternalData({ file, sourceNote }) {
      this.emitInput("sourceNote", sourceNote);

      this.$nextTick(() => {
        this.emitInput("file", file);
      });

      this.$emit("changed-external")

      this.fileMode = true;
    },
    setInitialData() {
      const initialValue = {
        sendType: this.channelData.sendType,
        sourceNote: this.channelData.sourceNote,
      };

      if (this.channelData.configuration) {
        const configuration = JSON.parse(this.channelData.configuration);       

        if (Array.isArray(configuration) || this.channelData.sendType === "CUSTOM_SEGMENTED_LIST") {
          initialValue.configuration = configuration;
        } else {          
          initialValue.configuration =
            configuration.configurationSimplesSegmentedList;
        }
      }      
      this.$emit("input", initialValue);
    },
  },

  async created() {   
    if (this.channelData) {
      this.setInitialData();
    }

    const totalLeads = await this.$api.core.clients.total();

    this.totalLeads = totalLeads;
  },

  beforeDestroy() {
    const initialValue = {
        sendType: this.value.sendType,
        sourceNote: this.value.sourceNote,
        configuration: this.hasSenderOptionChanged 
        ? this.value.configuration 
        : JSON.stringify({configurationSimplesSegmentedList: this.value.configuration}) 
      };
    this.$emit("input", initialValue);
  },

  computed: {
    isSegmentedList() {
      return this.value.sendType == "SIMPLE_SEGMENTED_LIST";
    },
    isExternalList() {
      return this.value.sendType == "EXTERNAL";
    },
    isCustomSegmentedList() {
      return this.value.sendType == "CUSTOM_SEGMENTED_LIST";
    },
    isEdit() {
      return !!this.channelData;
    },
    sendersOptions() {
      return [
        {
          label: this.$t('message.marketingGenerics.message.sendSegmentedList'),
          value: "SIMPLE_SEGMENTED_LIST",
        },
        {
          label: `${this.$t('message.marketingGenerics.message.sendEntireDataBase')} (${this.totalLeads} ${this.$t('message.marketingGenerics.message.leads')})`,
          value: "WHOLE_DATABASE",
        },
        {
          label: this.$t('message.marketingGenerics.message.importExternalBase'),
          value: "EXTERNAL",
        },
        {
          label: this.$t('message.marketingGenerics.message.customSegmentedList'),
          value: "CUSTOM_SEGMENTED_LIST",
        },
      ];
    },
    sendType() {
      return this.value.sendType
    },
    configurationInObjectFormat() {
      return typeof this.value.configuration === "object" ? 
                    this.value.configuration :
                    typeof this.value.configuration === "string" ?
                    JSON.parse(this.value.configuration) : 
                    undefined
    }    
  },

  mixins: [],
};
</script>

<style lang="scss" scoped>
.marketing-sms-form-senders {
  margin-bottom: 20px;
}
</style>
